import Component from 'vue-class-component';
import Vue from 'vue';
import {isCountryInNorthAmerica} from '../../CountryRestriction/CountryRestrictionUtility';

@Component({})
export default class NavigationShop extends Vue {
  private shopUrl = 'https://shop.faulhaber.com';

  private customerData: {
    customer: {fullname?: string, firstname?: string, websiteId?: string, data_id: number},
    cart: { summary_count: number, items: Array<any> },
  }|null = null;

  get isCountryPermitted(): boolean {
    return isCountryInNorthAmerica();
  }

  get isCustomerLoggedIn(): boolean {
    if (this.customerData && 'customer' in this.customerData && 'fullname' in this.customerData.customer) {
      return true;
    }
    return false;
  }

  get numberOfItemsInCart(): number {
    if (this.customerData && 'cart' in this.customerData && 'summary_count' in this.customerData.cart) {
      return this.customerData.cart.summary_count;
    }
    return 0;
  }

  mounted() {
    if (this.isCountryPermitted) {
      this.fetchFromShop();
    }
  }

  prepareCart() {
    const shoppingCart: HTMLLinkElement|null = document.querySelector('.js-shoppingCart');
    const firstHeader: HTMLDivElement|null = document.querySelector('#firstHeader');
    if (!shoppingCart || !firstHeader) {
      return;
    }
    const search: HTMLDivElement|null = firstHeader.querySelector('.search');
    if (!search) {
      return;
    }
    if (!firstHeader.querySelector('.js-shoppingCart')) {
      firstHeader.insertBefore(shoppingCart, search);
      this.toggleNavCart(shoppingCart);
    }
    window.addEventListener('resize', () => this.toggleNavCart(shoppingCart), {passive: true});
  }

  toggleNavCart(shoppingCart) {
    if (window.innerWidth < 769) {
      if (shoppingCart.classList.contains('hidden')) {
        shoppingCart.classList.toggle('hidden');
      }
    } else {
      if (!shoppingCart.classList.contains('hidden')) {
        shoppingCart.classList.toggle('hidden');
      }
    }
  }

  prepareMyAccount() {
    const mobileNav: HTMLLinkElement|null = document.querySelector('#mobileNav > .mm-list');
    const shoppingLinks: HTMLLinkElement|null = document.querySelector('.js-navigationShopLinks');

    if (mobileNav && shoppingLinks) {
      mobileNav.insertBefore(shoppingLinks, null);
    }
  }

  fetchFromShop() {
    const url = `${this.shopUrl}/customer/section/load/?sections=customer,cart`;
    fetch(url, {credentials: 'include', mode: 'cors'})
      .then((response) => response.json())
      .then((json) => this.customerData = json)
      .catch((reason => console.error(reason)))
      .finally(() => {
        this.prepareCart();
        this.prepareMyAccount();
      })
    ;
  }
}
